import { cva } from 'class-variance-authority';

export const cvaRoot = cva([
  'PvzMapDetailsHeaderStyles-cvaRoot',
  'px-2.4 sm:px-3.2 lg:px-8 pt-3.2 sm:pt-4.8 pb-3.2',
  'w-full',
  'bg-cLightGrey',
]);

export const cvaTitle = cva(['PvzMapDetailsHeaderStyles-cvaTitle', 'mb-2.4', 'text-h3 font-secondary']);

export const cvaAddress = cva([
  'PvzMapDetailsHeaderStyles-cvaAddress',
  'block w-full',
  'mb-0.4',
  'text-bodyM !font-semibold',
]);

export const cvaWorkingHours = cva([
  'PvzMapDetailsHeaderStyles-cvaWorkingHours',
  'inline-block',
  'relative',
  'pl-2.4',
  'mb-0.4',
  'text-bodyM text-cBlack text-opacity-[0.48]',
]);

export const cvaWorkingHoursIcon = cva([
  'PvzMapDetailsHeaderStyles-cvaWorkingHoursIcon',
  'absolute left-0 top-0.4',
  'w-1.6 h-1.6',
  'fill-cBlack opacity-[0.48]',
]);

export const cvaPhone = cva([
  'PvzMapDetailsHeaderStyles-cvaPhone',
  'relative',
  'pl-2.4',
  'mb-2.4',
  'text-bodyM !font-semibold text-cMediumGreen',
  'flex',
]);

export const cvaPhoneIcon = cva([
  'PvzMapDetailsHeaderStyles-cvaPhoneIcon',
  'absolute top-1/2 left-0 -translate-y-1/2',
  'w-1.6 h-1.6',
]);

export const cvaHowToGet = cva(['PvzMapDetailsHeaderStyles-cvaHowToGet', 'mb-2.4']);

export const cvaHowToGetTitle = cva(['PvzMapDetailsHeaderStyles-cvaHowToGetTitle', 'text-bodyM !font-semibold']);

export const cvaHowToGetDescr = cva(
  ['PvzMapDetailsHeaderStyles-cvaHowToGetDescr', 'text-bodyM text-cBlack text-opacity-[0.48] max-w-[40rem]'],
  {
    variants: {
      revealed: {
        true: [''],
        false: ['truncate'],
      },
    },
  }
);

export const cvaTimeToPvz = cva(['PvzMapDetailsHeaderStyles-cvaTimeToPvz', '']);

export const cvaTimeToPvzTitle = cva([
  'PvzMapDetailsHeaderStyles-cvaTimeToPvzTitle',
  'text-bodyM text-cBlack text-opacity-[0.48]',
]);

export const cvaTimeToPvzDescr = cva(['PvzMapDetailsHeaderStyles-cvaTimeToPvzDescr', 'text-bodyM !font-semibold']);

export const cvaTimeAndPrice = cva(['PvzMapDetailsHeaderStyles-cvaTimeAndPrice', 'grid grid-cols-2 gap-1.2']);
